import { GET } from "@store/methods";

// product insight sidebar
export const fetchSidebarProducts = (params) => {
  return GET("/fetch-sidebar-product-list", params);
};

// product insight sidebar subsection list
export const fetchSidebarProductsSubsectionList = (params) => {
  return GET("/fetch-sidebar-subsection-list", params);
};

// global consumption
export const fetchTableData = ({ url, params }) => {
  return GET(`/${url}`, params);
};

// global consumption html
export const fetchHTML = ({ url, params }) => {
  return GET(`/${url}`, params);
};
